// @flow

import * as fp from "lodash/fp"

export function parseRefFlagsFromQuery(value: string): Array<string> {
  if (!value) {
    return []
  }

  return fp.pipe(
    fp.castArray,
    fp.map(x => x.split(",")),
    fp.flatten,
  )(value)
}

// $FlowFixMe: error revealed by updating Flow and lodash libdef, please fix
export const setSerializedRefFlags = fp.curry((propName, refFlags, target) =>
  Array.isArray(refFlags) && refFlags.length
    ? { ...target, [propName]: refFlags.join(",") }
    : target,
)
